import { useEffect, useState } from 'preact/hooks';
import { api } from './api.js';
import type { CoinMe } from '../shared/coins.js';

// The player's AreCoin (2026-10-01): one shared copy for the top bar and the account page; games call
// refreshCoins() after a bet or a win.

let current: CoinMe | null = null;
const listeners = new Set<(c: CoinMe | null) => void>();

function publish(next: CoinMe | null) {
  current = next;
  for (const l of listeners) l(next);
}

export async function refreshCoins(): Promise<void> {
  try {
    publish(await api<CoinMe>('GET', '/api/coins'));
  } catch {
    // a guest or offline: keep what we have
  }
}

export async function refillCoins(): Promise<void> {
  publish(await api<CoinMe>('POST', '/api/coins/refill'));
}

/** The balance, kept fresh: on mount, every minute and when the window gets the focus. */
export function useCoins(enabled: boolean): CoinMe | null {
  const [coins, setCoins] = useState<CoinMe | null>(current);
  useEffect(() => {
    if (!enabled) return;
    listeners.add(setCoins);
    void refreshCoins();
    const timer = setInterval(() => void refreshCoins(), 60_000);
    const focus = () => void refreshCoins();
    addEventListener('focus', focus);
    return () => {
      listeners.delete(setCoins);
      clearInterval(timer);
      removeEventListener('focus', focus);
    };
  }, [enabled]);
  return enabled ? coins : null;
}
